function CommuneHeader(el) {
    this.el = el;
    this.videoWrapper = this.el.querySelector('.jsCommuneHeaderVideoWrapper');
    this.videoEl = this.el.querySelector('.jsCommuneHeaderVideo');

    // Init VideoJS
    if (this.videoEl) {
        videojs(this.videoEl);
        this.videoWrapperEl = this.videoWrapper.querySelector('div');
    }

    // Set the header video aspect ratio
    this.setAspectRatio();
    window.addEventListener('resize', _ => this.setAspectRatio());

    const downButtonEl = this.el.querySelector('.jsDownBtn');
    downButtonEl.addEventListener('click', e => {
        e.preventDefault();

        const offset = this.el.getBoundingClientRect();
        vanillaSmoothie.scrollTo(window.scrollY + (this.el.offsetHeight + offset.top), { duration: 500, easing: 'easeInOutQuad' });
    });
}

CommuneHeader.prototype.setAspectRatio = function() {
    if (this.videoWrapperEl) {
        const ratio = [16, 9];
        const minHeight = this.el.offsetHeight;

        this.videoWrapperEl.style.width = '';
        this.videoWrapperEl.style.height = '';

        let newWidth = window.innerWidth;
        let newHeight = (this.videoWrapperEl.offsetWidth / ratio[0]) * ratio[1];

        if (newHeight < minHeight) {
            newHeight = minHeight;
            newWidth = (newHeight / ratio[1]) * ratio[0];
        }

        this.videoWrapperEl.style.width = newWidth + 'px';
        this.videoWrapperEl.style.height = newHeight + 'px';
    }
};

(function() {
    const headerEl = document.querySelector('.jsCommuneHeader');
    if (headerEl) new CommuneHeader(headerEl);
})();